/*
  BebeLux lazy video loader
  - Targets <video class="bb-lazy-video"> elements rendered with
    preload="none"/"metadata" and WITHOUT an autoplay attribute.
  - Videos additionally marked with the class "bb-autoplay" are
    muted-autoplay videos: playback starts once the element scrolls
    near the viewport (IntersectionObserver, rootMargin 200px).
  - Videos inside a Swiper slide only start when their slide is active;
    otherwise the section's own Swiper controller decides (avoids
    fighting the carousel play/pause logic). A carousel script can set
    data-bb-wants-play="1" on a not-yet-hydrated video to have it
    played on first intersection.
  - Observation happens per container (.swiper root or the video
    itself) so slides cloned by Swiper loop mode are hydrated too.
  - Optional data-src on the <video> or on child <source> elements is
    applied on first intersection (full lazy source loading).
  - Fallback without IntersectionObserver: hydrate everything at once.
  - Guarded against double initialisation (script may be included by
    several sections).
*/
(function () {
  'use strict';

  if (window.__bbLazyVideoInit) return;
  window.__bbLazyVideoInit = true;

  var SELECTOR = 'video.bb-lazy-video';

  function describePosterImages(video) {
    var section = video.closest ? video.closest('section') : null;
    var heading = section ? section.querySelector('h1, h2, h3') : null;
    var label = heading && heading.textContent.trim() ? heading.textContent.trim() : 'BebeLux-Produktvideo';
    var images = video.querySelectorAll('img');
    for (var i = 0; i < images.length; i++) {
      if (!images[i].getAttribute('alt')) images[i].setAttribute('alt', label);
    }
  }

  function maybePlay(video) {
    var forced = video.dataset.bbWantsPlay === '1';
    var wantsPlay = forced || video.classList.contains('bb-autoplay');
    if (!wantsPlay) return;

    var slide = video.closest ? video.closest('.swiper-slide') : null;
    if (slide && !slide.classList.contains('swiper-slide-active') && !forced) {
      // Non-active carousel slide: the carousel script plays it on activation.
      return;
    }

    video.muted = true;
    video.playsInline = true;
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function hydrate(video) {
    if (video.dataset.bbReady) return;
    video.dataset.bbReady = '1';
    describePosterImages(video);

    var changed = false;
    if (video.dataset.src) {
      video.src = video.dataset.src;
      changed = true;
    }
    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].src = sources[i].getAttribute('data-src');
      changed = true;
    }
    if (changed) video.load();

    maybePlay(video);
  }

  function hydrateRoot(root) {
    if (root.matches && root.matches(SELECTOR)) {
      hydrate(root);
      return;
    }
    var videos = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < videos.length; i++) hydrate(videos[i]);
  }

  function init() {
    var videos = document.querySelectorAll(SELECTOR);
    if (!videos.length) return;
    for (var v = 0; v < videos.length; v++) describePosterImages(videos[v]);

    // Observe the surrounding swiper container (if any) instead of the
    // single video, so slides cloned later by Swiper loop mode are
    // hydrated together with their originals on intersection.
    var roots = [];
    for (var i = 0; i < videos.length; i++) {
      var root = videos[i].closest ? videos[i].closest('.swiper') : null;
      if (!root) root = videos[i];
      if (roots.indexOf(root) === -1) roots.push(root);
    }

    if (!('IntersectionObserver' in window)) {
      for (var k = 0; k < roots.length; k++) hydrateRoot(roots[k]);
      return;
    }

    var pending = roots.length;
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          io.unobserve(entries[i].target);
          pending--;
          hydrateRoot(entries[i].target);
        }
        if (pending <= 0) io.disconnect();
      },
      { rootMargin: '200px 0px' }
    );

    for (var j = 0; j < roots.length; j++) io.observe(roots[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
